<template>
  <div>
    <a-row style="margin: 0 -12px">
      <a-col
        style="padding: 0 12px"
        :xl="6"
        :lg="24"
        :md="24"
        :sm="24"
        :xs="24"
      >
        <a-card title="权限组" :bordered="false" :loading="loadingData">
          <a slot="extra" @click="createRoleAction">
            <a-icon type="plus" />新建
          </a>
          <a-input-search
            v-model="searchRoleVal"
            style="margin-bottom: 8px"
            placeholder="请输入名称"
          />
          <ul class="roles">
            <li
              v-for="role in roleList"
              :key="role.id"
              @click="onClickRole(role)"
              :class="{ active: activeRole.id == role.id }"
            >
              {{ role.roleName }}

              <a-dropdown :trigger="['click']">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-icon type="more" />
                </a>
                <div slot="overlay" class="actions">
                  <p @click="editRoleAction(role)">编辑</p>
                  <a-popconfirm
                    title="确认删除吗?"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="delRole(role.id)"
                  >
                    <p>删除</p>
                  </a-popconfirm>
                </div>
              </a-dropdown>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col
        style="padding: 0 12px"
        :xl="18"
        :lg="24"
        :md="24"
        :sm="24"
        :xs="24"
      >
        <a-card
          :loading="loadingData || loading"
          :bordered="false"
          :title="activeRole.roleName ? activeRole.roleName : '...'"
        >
          <div class="btn-group">
            <a-button type="primary" @click="openGrantRoleUserModal"
              >添加用户</a-button
            >
            <a-button
              style="margin-left: 8px"
              @click="grantRoleMenuModal = true"
              >菜单授权</a-button
            >
            <a-button
              style="margin-left: 8px"
              @click="grantRoleItemModal = true"
              >事项授权</a-button
            >
            <a-button style="margin-left: 8px" @click="grantRoleOrgModal = true"
              >数据授权</a-button
            >
            <a-button style="margin-left: 8px" @click="grantRoleOptModal = true"
              >操作授权</a-button
            >
          </div>

          <a-table
            :columns="columns"
            :data-source="dataSource"
            :loading="loading"
            :pagination="pagination"
            :rowKey="(row) => row.id"
          >
            <span slot="status" slot-scope="text">
              {{ text == 0 ? "正常" : "禁用" }}
            </span>
            <span slot="action" slot-scope="row">
              <a-popconfirm
                title="确认删除吗?"
                ok-text="是"
                cancel-text="否"
                @confirm="delUser(row.id)"
              >
                <a-button type="link" size="small">删除</a-button>
              </a-popconfirm>
            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <a-modal v-model="grantRoleUserModal" title="选择人员" @ok="addUserRole">
      <div class="box">
        <div class="box-header">
          <div class="tabs">
            <span
              :class="{ active: userTreeParams.type == '部门' }"
              @click="
                () => {
                  userTreeParams.type = '部门';
                  loadUserTreeData();
                }
              "
              >部门</span
            >
            <span
              :class="{ active: userTreeParams.type == '学院' }"
              @click="
                () => {
                  userTreeParams.type = '学院';
                  loadUserTreeData();
                }
              "
              >学院</span
            >
          </div>
          <div>已选择</div>
        </div>
        <div class="box-body">
          <div class="box-item">
            <a-input-search
              style="margin-bottom: 8px"
              placeholder="请输入姓名"
              v-model="userTreeParams.name"
              @change="loadUserTreeData"
            />
            <a-tree
              v-model="checkedUserKeys"
              checkable
              :replaceFields="userTreeFieldNames"
              :tree-data="userTreeData"
            />
          </div>
          <div class="box-item">
            <ul>
              <li
                v-for="item in checkedUserKeys"
                :key="item"
                v-text="id2name(item)"
              ></li>
            </ul>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="grantRoleItemModal" title="事项授权" @ok="addRoleItem">
      <a-form>
        <a-form-item
          label="授权范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-radio-group v-model="currentRoleItemFrom.type">
            <a-radio value="all">全部业务</a-radio>
            <a-radio value="current">所在部门业务</a-radio>
            <a-radio value="appoint">指定范围</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="currentRoleItemFrom.type == 'appoint'"
          label="指定范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-checkbox-group
            style="width: 100%"
            class="line-block"
            v-model="currentRoleItemFrom.itemIds"
          >
            <a-checkbox v-for="item in items" :value="item.id" :key="item.id">{{
              item.itemName
            }}</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model="grantRoleMenuModal" title="菜单授权" @ok="addRoleMenu">
      <a-tree
        v-model="checkedMenuKeys"
        checkable
        :replaceFields="menuFieldNames"
        :tree-data="menuTreeData"
      />
    </a-modal>
    <a-modal
      v-model="grantRoleOrgModal"
      title="数据授权"
      @ok="addRoleOrganization"
    >
      <a-form>
        <a-form-item
          label="学历范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-checkbox-group v-model="currentRoleOrgFrom.educations">
            <a-checkbox
              v-for="item in educationList"
              :value="item.code"
              :key="item.code"
              >{{ item.name }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item
          label="授权范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-radio-group v-model="currentRoleOrgFrom.type">
            <a-radio value="all">全部学生</a-radio>
            <a-radio value="current">所在学院学生</a-radio>
            <a-radio value="appointOrg">指定学院</a-radio>
            <a-radio value="appointBuilding">指定宿舍</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-show="currentRoleOrgFrom.type == 'appointOrg'"
          label="指定范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-checkbox-group
            style="width: 100%"
            class="line-block"
            v-model="currentRoleOrgFrom.orgIds"
          >
            <a-checkbox
              v-for="item in orgList"
              :value="item.id"
              :key="item.id"
              >{{ item.orgName }}</a-checkbox
            >
          </a-checkbox-group>
        </a-form-item>
        <a-form-item
          v-show="currentRoleOrgFrom.type == 'appointBuilding'"
          label="指定范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-tree
            v-model="currentRoleOrgFrom.buildings"
            checkable
            :replaceFields="buildingTreeFieldNames"
            :tree-data="buildList"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model="grantRoleOptModal" title="操作授权" @ok="addRoleOpt">
      <a-form>
        <a-form-item
          label="操作范围"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-checkbox-group v-model="currentRoleOptFrom.dicIds">
            <a-checkbox
              v-for="item in optList"
              :value="item.code"
              :key="item.code"
              >{{ item.name }}</a-checkbox
            >
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model="roleSubmitModal"
      :title="currentRole.id ? '编辑' : '新建'"
      @ok="submitRole"
    >
      <a-form-model
        ref="addquanxianzu"
        :model="currentRole"
        :rules="addquanxianzuRules"
      >
        <a-form-model-item
          prop="roleName"
          label="名称"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-input v-model="currentRole.roleName" placeholder="请输入名称" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { role, authority } from "@/services";
import { getMenuTree, getRoleMenuTree } from "@/services/menu";
import { getOrgAndUserTree, getUserByRoleId } from "@/services/user";
import { getTreeByCode, getSelectedTreeByCode } from "@/services/dict";

function listCheckId(data, keyName, checkableName, childrenName) {
  let result = [];
  data.forEach((item) => {
    if (item[checkableName]) {
      result.push(item[keyName]);
    }
    if (item[childrenName] && item[childrenName].length) {
      result = result.concat(
        listCheckId(item[childrenName], keyName, checkableName, childrenName)
      );
    }
  });
  return result;
}

const columns = [
  {
    title: "账号名称",
    dataIndex: "userAccount",
  },
  {
    title: "姓名",
    dataIndex: "userName",
  },
  {
    title: "手机号",
    dataIndex: "userMobile",
  },
  {
    title: "部门/学院",
    dataIndex: "orgName",
  },
  // {
  //   title: "事项范围",
  //   dataIndex: "itemRange",
  // },
  // {
  //   title: "数据范围",
  //   dataIndex: "dataRange",
  // },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const dataSource = [];

const roleParams = {
  roleName: undefined,
  status: 0,
};

const menuTreeData = [];
const menuFieldNames = {
  title: "menuName",
  key: "id",
  children: "menuList",
};
const buildingTreeFieldNames = {
  title: "name",
  key: "code",
  children: "entries",
};
const userTreeData = [];

const userTreeParams = {
  type: "部门",
  roleId: undefined,
  name: undefined,
};
const userTreeFieldNames = {
  title: "name",
  key: "id",
  children: "list",
};
const educationList = [];
export default {
  name: "Role",
  data() {
    return {
      addquanxianzuRules: {
        roleName: [
          { required: true, message: "请填写名称", trigger: "change" },
        ],
      },
      columns,
      dataSource,
      loading: false,
      loadingData: false,
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      visible: false,
      grantRoleUserModal: false,
      grantRoleItemModal: false,
      grantRoleMenuModal: false,
      grantRoleOrgModal: false,
      grantRoleOptModal: false,
      roleSubmitModal: false,
      expandedKeys: ["0-0-0", "0-0-1"],
      autoExpandParent: true,
      checkedUserKeys: [],
      selectedKeys: [],
      userTreeParams,
      userTreeFieldNames,
      userTreeData,
      menuTreeData,
      id2NameMap: {},
      menuFieldNames,
      buildingTreeFieldNames,
      checkedMenuKeys: [],
      roleParams,
      roles: [],
      currentRole: {},
      activeRole: {},
      items: [],
      currentRoleItemFrom: { roleId: undefined, itemIds: [], type: "all" },
      orgList: [],
      buildList: [],
      currentRoleOrgFrom: {
        roleId: undefined,
        buildings: [],
        type: "all",
        orgIds: [],
        educations: [],
      },
      optList: [],
      currentRoleOptFrom: { roleId: undefined, defineCode: "CZAN", dicIds: [] },
      searchRoleVal: undefined,
      params: {
        pageIndex: 0,
        pageSize: 10,
        roleId: undefined,
      },
      educationList,
    };
  },
  watch: {
    checkedUserKeys(val) {
      console.log("onCheck", val);
    },
  },
  methods: {
    openGrantRoleUserModal() {
      this.grantRoleUserModal = true;
      this.checkedUserKeys = [];
    },
    async aaa(_rule, value) {
      if (value === "") {
        return Promise.reject("请输入名称");
      } else {
        if (this.currentRole.roleName !== "") {
          this.$refs.formRef.value.validateFields("roleName");
        }
        return Promise.resolve();
      }
    },
    onChange() {
      console.log("onChange");
    },
    handleOk() {
      this.modal = false;
    },
    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedUserKeys) {
      console.log("onCheck", checkedUserKeys);
      this.checkedUserKeys = checkedUserKeys;
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
    onClickRole(role) {
      this.activeRole = role;
      this.params.roleId = role.id;
      this.userTreeParams.roleId = role.id;
      this.loadRoleInfo();
    },
    // loadData() {
    //   this.loading = true;
    //   getUserByRoleId(this.params).then((res) => {
    //     const pagination = { ...this.pagination };
    //     pagination.total = res.total;
    //     this.dataSource = res.records;
    //     this.loading = false;
    //     this.pagination = pagination;
    //   });
    //   // queryAll(this.params).then((res) => {
    //   //   const pagination = { ...this.pagination };
    //   //   pagination.total = res.total;
    //   //   this.dataSource = res.records;
    //   //   this.loading = false;
    //   //   this.pagination = pagination;
    //   // });
    // },
    // handleTableChange(pagination) {
    //   console.log(pagination);
    //   const pager = { ...this.pagination };
    //   pager.current = pagination.current;
    //   this.pagination = pager;
    //   this.params.pageIndex = pagination.current;
    //   this.params.pageSize = pagination.pageSize;
    //   this.loadData();
    // },
    // search() {
    //   const pager = { ...this.pagination };
    //   pager.current = 1;
    //   pager.pageSize = this.params.pageSize;
    //   this.handleTableChange(pager);
    // },

    loadData() {
      this.loading = true;
      getUserByRoleId(this.params).then((res) => {
        this.dataSource = res.records;
        this.loading = false;
        this.pagination.current = res.current;
        this.pagination.total = res.total;
      });
    },
    onPageChange(page) {
      this.params.pageIndex = page;
      this.loadData();
    },
    search() {
      this.onPageChange(1);
    },
    loadRoleInfo() {
      const role = this.activeRole;
      getRoleMenuTree({ roleId: role.id }).then((res) => {
        this.checkedMenuKeys = listCheckId(res, "id", "checked", "menuList");
      });
      authority
        .getRoleItemInfo({
          roleId: role.id,
        })
        .then((res) => {
          this.items = res.dataList;
          this.currentRoleItemFrom.type = res.type;
          this.currentRoleItemFrom.roleId = role.id;
          this.currentRoleItemFrom.itemIds = res.dataList
            .filter((o) => o.checked)
            .map((o) => o.id);
        });
      authority
        .getRoleOrgInfo({
          roleId: role.id,
        })
        .then((res) => {
          this.orgList = res.orgList;
          this.buildList = res.buildList;
          this.currentRoleOrgFrom.educations = res.education.split(",");
          this.currentRoleOrgFrom.type = res.type;
          this.currentRoleOrgFrom.roleId = role.id;
          this.currentRoleOrgFrom.orgIds = res.orgList
            .filter((o) => o.checked)
            .map((o) => o.id);
          this.currentRoleOrgFrom.buildings = listCheckId(
            res.buildList,
            "code",
            "checked",
            "entries"
          );
        });
      getSelectedTreeByCode(role.id, "CZAN").then((res) => {
        this.optList = res;
        this.currentRoleOptFrom.roleId = role.id;
        this.currentRoleOptFrom.dicIds = listCheckId(
          res,
          "code",
          "checked",
          "entries"
        );
      });
      this.loadUserTreeData();

      this.search();
    },
    loadUserTreeData() {
      console.log("获取列表前的数据", this.userTreeParams);
      getOrgAndUserTree(this.userTreeParams).then((res) => {
        res
          .filter((o) => !o.id)
          .forEach((o) => {
            o.id = "temp" + Math.round(Math.random() * 100000);
            // o.disabled = true
          });
        // 暂时两级
        res.forEach((o) => {
          o.list.forEach((l) => {
            if (l.id.indexOf("temp") < 0) {
              this.id2NameMap[l.id] = l.name;
            }
          });
        });
        this.userTreeData = res;
        console.log(this.userTreeData);
      });
    },
    id2name(id) {
      return this.id2NameMap[id];
    },
    editRoleAction(item) {
      this.currentRole = Object.assign({}, item);
      this.roleSubmitModal = true;
    },
    createRoleAction() {
      this.currentRole = {};
      this.roleSubmitModal = true;
    },
    //加载角色列表
    async loadRole() {
      const d = await role.getAll();
      console.info("loadRole", d);
      this.roles = d;
    },
    //添加角色
    async submitRole() {
      this.$refs.addquanxianzu.validate(async (valid) => {
        if (valid) {
          if (this.currentRole.id) {
            const d = await role.update(this.currentRole);
            console.info("submitRole", d);
          } else {
            const d = await role.save(this.currentRole);
            console.info("submitRole", d);
          }
          this.$message.success("操作成功");
          this.loadRole();
          this.roleSubmitModal = false;
        }
      });
    },
    //删除角色
    async delRole(id) {
      await role.deleteById({ id });
      this.$message.success("操作成功");
      this.loadRole();
    },
    async addUserRole() {
      await authority.addUserRole({
        roleId: this.activeRole.id,
        userIds: this.checkedUserKeys.join(","),
      });
      this.$message.success("操作成功");
      this.loadUserTreeData();
      this.search();
      this.grantRoleUserModal = false;
    },
    async delUser(id) {
      await authority.removeUserRole({
        roleId: this.activeRole.id,
        userId: id,
      });
      this.$message.success("操作成功");
      this.loadUserTreeData();
      this.search();
    },
    async addRoleMenu() {
      await authority.addRoleMenu({
        roleId: this.activeRole.id,
        menuIds: this.checkedMenuKeys.join(","),
      });
      this.$message.success("操作成功");
      this.grantRoleMenuModal = false;
      this.loadRoleInfo();
    },
    async addRoleItem() {
      let data = Object.assign({}, this.currentRoleItemFrom);
      data.itemIds = data.itemIds.join(",");
      await authority.addRoleItem(data);
      this.$message.success("操作成功");
      this.grantRoleItemModal = false;
      this.loadRoleInfo();
    },
    async addRoleOrganization() {
      let data = Object.assign({}, this.currentRoleOrgFrom);
      data.education = data.educations.join(",");
      if (data.type == "appointBuilding") {
        data.orgIds = undefined;
        data.buildings = data.buildings.join(",");
      } else {
        data.buildings = undefined;
        data.orgIds = data.orgIds.join(",");
      }
      await authority.addRoleOrganization(data);
      this.$message.success("操作成功");
      this.grantRoleOrgModal = false;
      this.loadRoleInfo();
    },
    async addRoleOpt() {
      let data = Object.assign({}, this.currentRoleOptFrom);
      data.dicIds = data.dicIds.join(",");
      await authority.addRoleDic(data);
      this.$message.success("操作成功");
      this.grantRoleOptModal = false;
      this.loadRoleInfo();
    },
  },
  computed: {
    roleList() {
      return this.roles.filter((item) => {
        return (
          !this.searchRoleVal || item.roleName.indexOf(this.searchRoleVal) > -1
        );
      });
    },
  },
  async mounted() {
    this.loadingData = true;
    await this.loadRole();
    if (this.roles.length) {
      getMenuTree().then((res) => {
        this.menuTreeData = res;
        this.onClickRole(this.roles[0]);
      });
    }
    this.educationList = await getTreeByCode("XL");
    this.loadingData = false;
    console.info("educationList", this.educationList);
  },
};
</script>

<style lang="less" scoped>
.actions {
  background: #fff;
  border: 1px solid #e5e5e5;
}
.roles {
  list-style: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;

  li {
    padding: 15px 0;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .active {
    color: @primary-color;
  }
}

.box {
  border: 1px solid #eee;

  .box-header {
    padding: 10px;
    background: #eee;
    display: flex;
    justify-content: space-around;

    span {
      padding: 0 10px;
    }
  }

  .box-body {
    background: #fff;
    display: grid;
    grid-template-columns: 2fr 1fr;

    .box-item {
      padding: 20px;
      border-right: 1px solid #eee;
    }

    .input-search {
      margin-bottom: 8px;
    }

    .tree {
      height: 300px;
    }

    ul {
      list-style: none;
      padding-inline-start: 0;
      margin-block-start: 0;
      margin-block-end: 0;
    }
  }
}

.line-block {
  > * {
    display: block;
    margin: 0;
  }
}

.active {
  color: @primary-color;
}

.tabs > * {
  &:hover {
    cursor: pointer;
  }
}
</style>

